import { useDispatch } from 'react-redux';
import FacebookLogin from 'react-facebook-login';
// import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';

import { basicMsg } from '../../../actions/swal_msg';
import { facebookLogin } from '../../../actions/user';

const FacebookLoginButton = () => {
    const dispatch = useDispatch();

    const handleFacebookCallback = (response) => {
        if (response?.status === "unknown") {
            basicMsg('No se pudo continuar con Facebook');
            return;
        }
        if (response) {
            const { email, name, expiresIn, userID } = response;
            if (email && name && expiresIn) {
                dispatch(facebookLogin({
                    expiresIn,
                    facebookId: userID,
                    email,
                    username: name,
                    fullname: name,
                    password: '',
                    origin: 'Facebook',
                    page: 'mi-cuenta'
                }));
            }
        }
    };

    return (
        <FacebookLogin 
            buttonStyle={{ padding: "6px", width: '100%', height: '55px' }}
            appId={ process.env.REACT_APP_FACEBOOK_APP_ID }
            autoLoad={false}
            fields="name,email,picture"
            callback={ handleFacebookCallback }
            textButton="Continuar con Facebook"
        />
    );
};

export default FacebookLoginButton;